import { tracking, _t } from '@bark/bark-core';

export const SubscriptionUpsellCallbackError = (msg) => {
	const container = $('.js-callback-error-container');
	container.removeClass('d-none');
	$('.js-msg', container).text(msg);
};

export const IsSubscriptionUpsellActive = () => {
	return $('.subscription-upsell-launcher').length;
};

export const SubscriptionUpsellBindEvents = (seller) => {
	$('#subscription-upsell-callback-name').val(seller.seller_name);
	$('#subscription-upsell-callback-tel').val(seller.telephone);

	$('.subscription-upsell-credits-page-trigger')
		.off('click.openModal')
		.on('click.openModal', (e) => {
			e.preventDefault();
			tracking('credit_subscription', 'my_credit_CTA_clicked', {
				seller_profile_id: seller?.spf_id,
				country_id: seller?.country_id,
			});
			//For UK & US
			if ([236, 237].includes(seller?.country_id)) {
				window.location.replace('/settings/credits_subscription/subscribe');
			} else {
				if (
					$('#__rctCreditSubscriptionContactModal').length &&
					window.SellerAppDashboard
				) {
					window.SellerAppDashboard.launchModule(
						'credit-subscription-contact-modal',
						'__rctCreditSubscriptionContactModal',
						{},
					);
				} else {
					//Fallback
					$('#subscription-upsell-announce-modal .confirm-purchase')
						.removeClass('d-flex')
						.addClass('d-none');

					$('#subscription-upsell-announce-modal').data(
						'SubscriptionUpsellExperiment',
						'subscriptions_upsell_1',
					);

					$('#subscription-upsell-announce-modal').modal('show');
				}
			}
		});

	$('.js-close-subscription-upsell-modal')
		.off('click.closeModal')
		.on('click.closeModal', () => {
			$('.modal').modal('hide');
			tracking(
				$('#subscription-upsell-announce-modal').data('SubscriptionUpsellExperiment'),
				'click_no_thanks',
			);
		});

	$('.js-close-subscription-upsell-details-modal')
		.off('click.closeModal')
		.on('click.closeModal', () => {
			$('.modal').modal('hide');
			$('#subscription-upsell-announce-modal').modal('show');
			tracking(
				$('#subscription-upsell-announce-modal').data('SubscriptionUpsellExperiment'),
				'click_modal_close',
			);
		});

	$('.js-subscription-upsell-request-callback')
		.off('click.callbackRequest')
		.on('click.callbackRequest', function () {
			tracking(
				$('#subscription-upsell-announce-modal').data('SubscriptionUpsellExperiment'),
				'click_tell_me_more',
			);
			$('.modal').modal('hide');

			$('.js-callback-error-container').addClass('d-none');
			$('#subscription-upsell-callback-modal').modal('show');
		});

	$('.js-subscription-upsell-submit-callback-request')
		.off('click.submitRequest')
		.on('click.submitRequest', function () {
			let t = $(this);
			let spinner = $('.js-subscription-upsell-callback-spinner');
			let payload = {
				name: $('#subscription-upsell-callback-name').val(),
				tel: $('#subscription-upsell-callback-tel').val(),
			};

			t.addClass('d-none');
			spinner.removeClass('d-none');

			if (payload.name.length <= 0) {
				t.removeClass('d-none');
				spinner.addClass('d-none');
				SubscriptionUpsellCallbackError(
					_t('seller_settings_upsell-modal:input.name.error.empty'),
				);
				return;
			}

			if (payload.tel.length <= 0) {
				t.removeClass('d-none');
				spinner.addClass('d-none');
				SubscriptionUpsellCallbackError(
					_t('seller_settings_upsell-modal:input.tel.error.empty'),
				);
				return;
			}

			Bark.validate.ukTel(payload.tel, function (success, moderate) {
				if (success || (!success && moderate)) {
					Bark.api(
						'creditpack/subscription-upsell/callback',
						payload,
						(e) => {
							t.removeClass('d-none');
							spinner.addClass('d-none');

							if (e.status) {
								// Show success modal
								$('.modal').modal('hide');
								$('#subscription-upsell-callback-modal-success').modal('show');
								window.setTimeout(() => {
									$('#subscription-upsell-callback-modal-success').modal('hide');
								}, 6000);

								tracking(
									$('#subscription-upsell-announce-modal').data(
										'SubscriptionUpsellExperiment',
									),
									'submitted_callback_request',
								);
								return;
							}

							SubscriptionUpsellCallbackError(
								_t('seller_settings_upsell-modal:error.saving-request'),
							);
						},
						(e) => {
							let error = JSON.parse(e.responseText) || {};

							t.removeClass('d-none');
							spinner.addClass('d-none');

							SubscriptionUpsellCallbackError(
								error.message || _t('seller_settings_upsell-modal:error.saving-request'),
							);
						},
						'POST',
					);
				} else {
					t.removeClass('d-none');
					spinner.addClass('d-none');
					SubscriptionUpsellCallbackError(
						_t('seller_settings_upsell-modal:input.tel.error.invalid'),
					);
				}
			});
		});
};

export const exposeSubscriptionUpsellEventsToWindow = async () => {
	window.SubscriptionUpsellFunctions = {};
	window.SubscriptionUpsellFunctions.SubscriptionUpsellBindEvents =
		SubscriptionUpsellBindEvents;
	window.SubscriptionUpsellFunctions.IsSubscriptionUpsellActive =
		IsSubscriptionUpsellActive;
};
